import { CallStats, StatsCommon } from '#common/stats';
export class BlockStoreStats extends StatsCommon {
    name;
    get;
    put;
    constructor(name, log) {
        super();
        this.name = name;
        this.get = new CallStats('get', log);
        this.put = new CallStats('put', log);
    }
}
